import Vue from 'vue'
import moment from 'moment'
import * as R from 'ramda'
import util from '@/libs/util'
import firebase from '@/libs/firebase'

Vue.filter('readAtDisplay', (val) => {
  if (util.isEmpnil(val)) return '-'
  const formatDateStr = (d) => (util.isEmpnil(d) ? '' : moment(d).format('L'))
  const stringify = R.pipe(R.join(' ~ '), R.trim)

  return stringify([val.from, val.to].map(formatDateStr))
})

Vue.filter('normalize', (objects) => {
  return firebase.normalize(objects)
})

Vue.filter('cap', (val) => {
  if (!val) return ''
  val = val.toString()
  return val.charAt(0).toUpperCase() + val.slice(1)
})

Vue.filter('uppercase', (val) => val.toUpperCase())
